import React from "react";
import "./ListItemB.scss"
import moment from 'moment';
//@ts-ignore
import SimpleLineIcon from 'react-simple-line-icons';
//@ts-ignore
import StarRatingComponent from 'react-star-rating-component';
import { ListItemSmall } from "components/listItemSmall";
import { ButtonBase } from '@material-ui/core';

export interface ListItemBProps {
    item: any;
    titleKey?: string;
    backgroundColor?: string;
    onClick?(item: any): void;
    cancelAmount?: boolean;
}

export interface ListItemBState {
}

class ListItemB extends React.Component<ListItemBProps, ListItemBState> {
    constructor(props: ListItemBProps) {
        super(props);
        this.state = {};
    }

    handleClick(item: any) {
        if (this.props.onClick) {
            this.props.onClick(item);
        }
    }

    render() {
        return (
            <ButtonBase style={{
                outline: "none"
            }}
                disableRipple={false}
                focusRipple={true}
            >
                <div className="amount-info" onClick={() => this.handleClick(this.props.item)} style={{ backgroundColor: this.props.backgroundColor }}>
                    {/* <div style={{ width: "92%" }}> */}
                    <div className="rating-info">
                        <h1>{this.props.item.type}</h1>
                        {this.props.item.rating
                            ?
                            <StarRatingComponent
                                name="rate1"
                                starCount={5}
                                value={this.props.item.rating}
                                emptyStarColor={'#BDBDBD'}
                                starColor={'#F2994A'}
                                onStarClick={() => { }}
                            />
                            :
                            <ListItemSmall
                                listItem={this.props.item.summary}
                            />
                        }


                        <p>{this.props.item.area}</p>
                    </div>
                    <div className="name-info">
                        <p>{this.props.item.amount}</p>
                        {this.props.cancelAmount ? (
                            <p className="cancel-amount">$--</p>
                        )
                            : (
                                <p>{this.props.item.hour}</p>
                            )}
                    </div>

                    {/* </div> */}
                    {/* <div className="icon-right">
                        <SimpleLineIcon name="arrow-right" />
                    </div> */}
                </div></ButtonBase>
        );
    }
}

export default ListItemB;